import React, { useCallback, useEffect, useState } from 'react';
import {
  VuiPopUp,
  VuiFormGroup,
  VuiCustomScroll,
  VUI_PHOSPHOR_ICONS,
  VUI_PHOSPHOR_TAGS,
  VuiIcon,
} from '@topkamera/viso-ui';
import './SidebarSelectIcon.scss';

const SidebarSelectIcon = ({
  isVisible = false,
  onClose = () => { },
  onApply = () => { },
  initialValue,
}) => {
  const [searchValue, setSearchValue] = useState('')
  const [filteredIcons, setFilteredIcons] = useState([...VUI_PHOSPHOR_ICONS])
  const [selectedIcon, setSelectedIcon] = useState(initialValue || '')

  useEffect(() => {
    if (!isVisible) {
      return
    }

    setSelectedIcon(initialValue || '')
  }, [initialValue, isVisible])

  const handleClose = useCallback(() => {
    if (onClose) {
      onClose()
    }
  }, [onClose])

  const handleApply = useCallback((iconOverride) => {
    const iconToApply = typeof iconOverride === 'string' ? iconOverride : selectedIcon

    if (onApply) {
      onApply(iconToApply)
    }

    handleClose()
  }, [handleClose, onApply, selectedIcon])

  const onSearch = (value) => {
      setSearchValue(value)
      const query = value.trim().toLowerCase()
      const filteredIcons = VUI_PHOSPHOR_ICONS.filter((icon) => icon.toLowerCase().includes(query))
      const filteredTags = Object.entries(VUI_PHOSPHOR_TAGS).filter(([, tags]) => tags.some((tag) => tag.toLowerCase().includes(query))).map(([iconName]) => iconName)

      setFilteredIcons(
        Array.from(new Set([...filteredIcons, ...filteredTags])).sort((a, b) =>
          a.localeCompare(b, undefined, { sensitivity: 'base' })
        )
      )
    }

  return (
    <VuiPopUp
      isVisible={isVisible}
      invisibleOverlay
      title="Select Icon"
      confirmBtn={{
        color: 'success',
        label: 'Apply',
        style: 'color',
        onClick: () => handleApply(),
      }}
      cancelBtn={{
        color: 'accent1',
        label: 'Cancel',
        onClick: handleClose,
      }}
      closeOnConfirm
      onClose={handleClose}
    >
      <div className='viso-sidebar-select-icon'>
        <div className='viso-sidebar-popup-content'>
          <VuiFormGroup
            fieldProps={{
              onChange: (e) => onSearch(e?.target?.value ?? e ?? ''),
              value: searchValue,
            }}
            iconLeft={{
              name: 'search'
            }}
            label='Search icons...'
            fieldType="textinput"
            groupLayout="blank"
            id="searchIcons"
          />
        </div>
        <div className='viso-sidebar-select-icon__scroll'>
          <VuiCustomScroll
            fixedHeight={164}
            fadeBottom
          >
            <div className="vui-flex vui-flex-wrap vui-gap-8 vui-pt-10 vui-pb-32">
              {filteredIcons.map(icon => (
                <VuiIcon
                  key={icon}
                  name={icon}
                  color='label'
                  isButton
                  activeColor={selectedIcon === icon && 'accent0'}
                  onClick={() => setSelectedIcon(icon)}
                />
              ))}
            </div>
          </VuiCustomScroll>
        </div>
      </div>
    </VuiPopUp>
  )
}

export default SidebarSelectIcon